module.exports = __webpack_public_path__ + "static/media/item_2_4.e5e89a71.png";